import React from 'react';

import { FlexColumn } from 'ui-components/components/flex';

import { emptyObject } from 'ui-components/default-props/empty';
import PlanNameInfo from './plan-name-info';
import { PlanInfoDetails } from './plan-info-details';

import styles from './style.module.less';

const headerId = 'subscription-card-plan-info-header';

/**
 * @typedef {import('../../../../../prop-types/currency').Currency} Currency
 */

/**
 * @typedef {import('../../../../../prop-types/plan-info').PlanInfoPropType} PlanInfoPropType
 */

/**
 * @typedef {import('../../../../../prop-types/subscription-data-types.d.ts').SubscriptionData} SubscriptionData
 */

/**
 * @param {object} props
 * @param {PlanInfoPropType} props.planInfo
 * @param {SubscriptionData} props.subscriptionData
 * @param {Currency} [props.shipmentLimitPrice]
 * @returns {React.JSX.Element}
 */
export const SubscriptionCardPlanInfo = ({ planInfo = emptyObject, shipmentLimitPrice, basePlanPrice }) => {
  const shipmentLimit = planInfo?.plan?.shipmentLimit;

  return (
    <FlexColumn>
      <div aria-labelledby={headerId} className={styles['plan-name']}>
        <PlanNameInfo basePlanPrice={basePlanPrice} planInfo={planInfo} />
      </div>
      <PlanInfoDetails
        isShipmentLimitUnlimited={shipmentLimit?.isUnlimited}
        shipmentLimitCount={shipmentLimit?.limit}
        shipmentLimitPrice={shipmentLimitPrice}
      />
    </FlexColumn>
  );
};
